import { useMemo } from "react";
import { DefaultOptionType } from "antd/lib/select";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

type AssignedToOptionValue = string | number;

export const useAssignedToOptions = (
  projectUsers: DefaultOptionType[],
  assignedToId: AssignedToOptionValue | null | undefined,
  assignedTo: string | null | undefined
): DefaultOptionType[] => {
  const { t } = useTranslation(I18N_NS.GENERAL);

  return useMemo(() => {
    const options = projectUsers.slice();
    const hasAssignedUserOption = options.some((option) => String(option.value) === String(assignedToId));

    if (assignedToId !== null && assignedToId !== undefined && !hasAssignedUserOption) {
      options.push({
        label: assignedTo || t("[Removed user]", { ns: I18N_NS.GENERAL }),
        value: assignedToId,
        disabled: true,
      });
    }

    if (assignedToId == null && assignedTo) {
      options.push({
        label: assignedTo,
        value: null,
        disabled: true,
      });
    }

    return options;
  }, [projectUsers, t, assignedToId, assignedTo]);
};
